import React, { FC, useState } from 'react';

import FormErrorField from '@components/dashboard/common/FormErrorField';

import { Button, Form, Input, Modal, Result } from 'antd';
import { message } from 'antd';

import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { useSendBugReportMutation } from '@store/mailing/mailing.api';
import TextArea from 'antd/es/input/TextArea';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';

interface BugReportModalProps {
  isOpen: boolean;
  closeModal: () => void;
}

interface BugReportFormData {
  title: string;
  message: string;
}
const popupSchema = yup.object().shape({
  title: yup
    .string()
    .required('Error: title is a required field.')
    .test(
      'blank space',
      "Error: title can't start with a blank space",
      (value) => {
        if (!value) return false;
        return !value.startsWith(' ');
      },
    ),
  message: yup
    .string()
    .max(150, 'Error: 150 characters maximum')
    .required('Error: message is a required field.')
    .test(
      'blank space',
      "Error: message can't start with a blank space",
      (value) => {
        if (!value) return false;
        return !value.startsWith(' ');
      },
    ),
});
export const BugReportModal: FC<BugReportModalProps> = ({
  isOpen,
  closeModal,
}) => {
  const [sendBugReport] = useSendBugReportMutation(undefined);
  const [isBugReportSent, setIsBugReportSent] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const {
    handleSubmit,
    control,
    reset,
    getValues,
    formState: { errors },
  } = useForm<BugReportFormData>({
    resolver: yupResolver(popupSchema),
    mode: 'onTouched',
  });
  const handleReportBug = () => {
    try {
      sendBugReport({
        title: getValues('title'),
        message: getValues('message'),
      }).then((res: any) => {
        if (!res?.error || res?.error.status < 400) {
          setIsBugReportSent(true);
          return;
        }

        messageApi.destroy();
        messageApi.open({
          type: 'error',
          content: 'Server Error: please try later.',
        });
      });
    } catch (error) {}
  };
  return !isBugReportSent ? (
    <Modal
      title="Report a bug"
      open={isOpen}
      destroyOnClose={true}
      onOk={handleSubmit(handleReportBug)}
      onCancel={closeModal}
      okText="Send"
      afterClose={() => {
        reset();
        setIsBugReportSent(false);
      }}
    >
      {contextHolder}
      <Form
        name="basic"
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 18 }}
        style={{ resize: 'none' }}
        onFinish={handleSubmit(handleReportBug)}
        className="text-left leading-tight w-full pt-6"
      >
        <Form.Item
          label={<label className="text-blue">Title</label>}
          name="title"
          validateStatus={errors.title && 'error'}
          help={<FormErrorField>{errors.title?.message}</FormErrorField>}
        >
          <Controller
            name="title"
            control={control}
            render={({ field: { ...fieldProps } }) => (
              <Input {...fieldProps} placeholder="Alerts don't work" />
            )}
          />
        </Form.Item>
        <Form.Item
          label={<label className="text-blue">Message</label>}
          name="message"
          validateStatus={errors.message && 'error'}
          help={
            <FormErrorField className="absolute bottom-[-15px]">
              {errors.message?.message}
            </FormErrorField>
          }
        >
          <Controller
            name="message"
            control={control}
            render={({ field: { ...fieldProps } }) => (
              <TextArea
                {...fieldProps}
                showCount
                maxLength={150}
                placeholder="What went wrong?"
                className="h-28"
                style={{ resize: 'none' }}
              />
            )}
          />
        </Form.Item>
      </Form>
    </Modal>
  ) : (
    <Modal
      title="Report a bug"
      open={isOpen}
      destroyOnClose={true}
      footer={null}
      onCancel={closeModal}
      afterClose={() => {
        reset();
        setIsBugReportSent(false);
      }}
    >
      <Result
        status="success"
        title="Bug report was sent. Thank you for your feedback!"
        extra={[
          <Button
            type="primary"
            key="console"
            onClick={() => {
              closeModal();
            }}
          >
            Close
          </Button>,
        ]}
      />
    </Modal>
  );
};
